import IsibuteDocumentComponent from "./IsibuteDocumentComponent";

class IsibuteDocumentSubtitle extends IsibuteDocumentComponent {};

export default IsibuteDocumentSubtitle;
